import React from 'react';

interface TeamMemberCardProps {
  name: string;
  registration: string;
  description: string;
  imageUrl?: string;
  imageAlt?: string;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  nameWeight?: string;
  registrationWeight?: string;
  descriptionSize?: string;
  descriptionWeight?: string;
  borderRadius?: string;
  imageSize?: string;
  cardWidth?: string;
  gap?: string;
  padding?: string;
  fontFamily?: string;
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({
  name,
  registration,
  description,
  imageUrl = '',
  imageAlt = 'Team member photo',
  backgroundColor = 'bg-[#a6dd60]',
  borderColor = 'border-white',
  textColor = 'text-black',
  nameWeight = 'font-semibold',
  registrationWeight = 'font-light',
  descriptionSize = 'text-[13px] md:text-[15.5px]',
  descriptionWeight = 'font-light',
  borderRadius = 'rounded-[16px] md:rounded-[24px]',
  imageSize = 'w-[120px] h-[150px] md:w-[160px] md:h-[200px]',
  cardWidth = 'w-full max-w-[600px]',
  gap = 'gap-4 md:gap-8',
  padding = 'p-3 md:p-4',
  fontFamily = 'font-poppins'
}) => {
  return (
    <div className={`flex flex-row items-center justify-center ${gap} border ${borderColor} ${backgroundColor} border-[2.5px] ${borderRadius} ${padding} ${cardWidth}`}>
      <img 
        src={imageUrl}
        alt={imageAlt}
        className={`${borderRadius} ${imageSize} object-cover`}
      />
      <div className={`flex-1 max-w-[340px] flex flex-col ${fontFamily} ${textColor} text-[16px] md:text-[18.6px]`}>
        <p className={nameWeight}>
          {name}
        </p>
        <p className={registrationWeight}>
          {registration}
        </p>
        <p className={`${descriptionSize} ${descriptionWeight}`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default TeamMemberCard;